import { render, staticRenderFns } from "./UserSelectorDropdown.vue?vue&type=template&id=6f2283c6&"
import script from "./UserSelectorDropdown.vue?vue&type=script&lang=js&"
export * from "./UserSelectorDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VBtn,VCombobox})
